import { GridEditorBase } from "@/Common/Helpers/GridEditorBase";
import { SqlProcLookupParametersColumns } from "@/ServerTypes/Data/SqlProcLookupParametersColumns";
import { alertDialog, ComboboxEditor, Decorators, Dictionary, findElementWithRelativeId, indexOf, isTrimmedEmpty, notifyError, notifyWarning, StringEditor, trimToNull, tryFirst, tryGetWidget, WidgetProps } from "@serenity-is/corelib";
import { SqlProcLookupParameterDialog } from "./SqlProcLookupParameterDialog";
import { SqlProcLookupParameter } from "@/ServerTypes/Data/SqlProcLookupParameter";
import { DataParameter } from "@/ServerTypes/Data/DataParameter";
import { SqlProcLookupParameterService } from "@/ServerTypes/Data/SqlProcLookupParameterService";
import { SqlProcLookupObjectNameRow } from "@/ServerTypes/Data/SqlProcLookupObjectNameRow";

@Decorators.registerEditor("Matrix.Data.SqlProcLookupParametersEditor")
export class SqlProcLookupParametersEditor extends GridEditorBase<SqlProcLookupParameter> {
    protected override getColumnsKey() { return SqlProcLookupParametersColumns.columnsKey };
    protected override getDialogType() { return SqlProcLookupParameterDialog; }

    constructor(opt: WidgetProps<{}>) {
        super(opt);
        this.bindObjectNameUpdate();
    }

    protected tryGetRelativeWidget<TWidget>(name: string, type: {
        new(...args: any[]): TWidget;
    }): TWidget {
        return tryGetWidget(findElementWithRelativeId(this.element, name), type);
    }

    protected bindObjectNameUpdate() {
        const objectNameWidget = this.tryGetRelativeWidget("objectName", ComboboxEditor<any, SqlProcLookupObjectNameRow>);
        if (!objectNameWidget)
            return;

        objectNameWidget.changeSelect2(() => {
            const queryTypeWidget = this.tryGetRelativeWidget("queryType", StringEditor);

            if (isTrimmedEmpty(objectNameWidget.value))
            {
                queryTypeWidget.value = null;
                return;
            }

            queryTypeWidget.value = objectNameWidget.selectedItem.Type.toString();
            this.updateParameters();
        });

    }

    protected override getAddButtonCaption() {
        return "Add Parameter";
    }

    protected async updateParameters() {
        const objectNameWidget = this.tryGetRelativeWidget("objectName", ComboboxEditor<any, SqlProcLookupObjectNameRow>);
        if (!objectNameWidget) {
            notifyError("Object Name widget not found!");
            return;
        }

        const value = objectNameWidget.value;
        if (trimToNull(value) == null) {
            notifyWarning("Please select Object Name first!");
            return;
        }

        const response = await SqlProcLookupParameterService.ListParameters({
            ObjectName: value
        });

        const oldByName: Dictionary<DataParameter> = {};
        for (const k of (this.value || []))
            oldByName[k.Name] = k;

        this.value = (response.Entities || []).map(x => {
            const old = oldByName[x.Name];
            if (old) {
                old.Type = x.Type;
                old.Size = x.Size;
                old.Scale = x.Scale;
                return old;
            }
            return x;
        });
    }

    protected override getButtons() {
        const buttons = super.getButtons();

        const addIndex = indexOf(buttons, x => x.cssClass == "add-button");
        buttons[addIndex].icon = "fa-plus";

        buttons.push({
            title: "Update Parameters",
            cssClass: "update-parameters-button",
            icon: "fa-refresh",
            onClick: () => this.updateParameters()
        });

        return buttons;
    }


    override validateEntity(row: SqlProcLookupParameter, id: any) {
        const sameParameter = tryFirst(this.view.getItems(), x => x.Name === row.Name);
        if (sameParameter && this.id(sameParameter) !== id) {
            alertDialog("This parameter is already in parameter list!");
            return false;
        }

        return true;
    }
}
